import React from 'react'
import InnerBlogs from './Innercomponents/InnerBlogs'

function Blogs() {
  return (
   <>
  <InnerBlogs imgsrc="https://images.pexels.com/photos/9365604/pexels-photo-9365604.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              admin="Admin"
              date ="20 may"
              title = "Components can refer to other components in their output."
              content = "Components can refer to other components in their output. Components can refer to other components in their output."
              views= "102"
              comments= "12"
              likes = "50"
              button_read_more = "https://www.netflix.com/browse"
              />
              
 <InnerBlogs imgsrc="https://images.pexels.com/photos/9365604/pexels-photo-9365604.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              admin="Admin"
              date ="24 may"
              title = "ab Components can refer to other components in their output."
              content = " aff Components can refer to other components in their output. Components can refer to other components in their output."
              views= "105"
              comments= "18"
              likes = "70"
              button_read_more = "https://www.netflix.com/browse"
              />
  </> 
  )
}

export default Blogs